import { ref, computed, onMounted, onUnmounted } from 'vue'

// Simple global schedule modal controller
const _open = ref(false)
const _submitting = ref(false)
const _success = ref(false)
const _error = ref(null)
const _context = ref({
  type: 'trial', // 'trial' | 'demo' | 'consult' | 'quote'
  source: '',
  service: null, // 'erp' | 'marketing' | 'web' | 'media'
})

const _form = ref({
  name: '',
  email: '',
  phone: '',
  company: '',
  service: '',
  date: '',
  time: '',
  notes: '',
})

export const useScheduleModal = () => {
  const isOpen = computed(() => _open.value)
  const context = computed(() => _context.value)
  const form = computed({
    get: () => _form.value,
    set: (v) => (_form.value = v)
  })
  const resetForm = () => {
    _form.value = {
      name: '', email: '', phone: '', company: '', service: _context.value.service || '', date: '', time: '', notes: ''
    }
    _success.value = false
    _error.value = null
  }

  const openSchedule = (type = 'trial', payload = {}) => {
    _context.value = { type, source: payload.source || '', service: payload.service || null }
    if (!_form.value.service && payload.service) {
      _form.value.service = payload.service
    }
    _open.value = true
  }

  const closeSchedule = () => {
    _open.value = false
    setTimeout(resetForm, 250)
  }

  const submit = async () => {
    _submitting.value = true
    _error.value = null
    try {
      // Minimal front-end validation
      if (!_form.value.name || !_form.value.email || !_form.value.date || !_form.value.time) {
        throw new Error('โปรดกรอกชื่อ อีเมล วันที่ และเวลา')
      }
      // Demo: try POST to optional API, fallback to console
      if (typeof $fetch === 'function') {
        try {
          await $fetch('/api/schedule', { method: 'POST', body: { context: _context.value, form: _form.value } })
          _success.value = true
        } catch (e) {
          console.warn('No /api/schedule endpoint, logging locally.')
          _success.value = true
          console.log('Schedule Request', { context: _context.value, form: _form.value })
        }
      } else {
        _success.value = true
        console.log('Schedule Request', { context: _context.value, form: _form.value })
      }
    } catch (e) {
      _error.value = e?.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่'
    } finally {
      _submitting.value = false
    }
  }

  const listenEsc = (e) => {
    if (e.key === 'Escape' && _open.value) closeSchedule()
  }

  onMounted(() => window.addEventListener('keydown', listenEsc))
  onUnmounted(() => window.removeEventListener('keydown', listenEsc))

  return { isOpen, context, form, openSchedule, closeSchedule, submit, submitting: _submitting, success: _success, error: _error }
}
